// extracted by mini-css-extract-plugin
export default {"button":"Button1_button__0itQ2"};